module.exports = __webpack_public_path__ + "img/hero-2.d3149353.png";